export default "/images/vendor/flag-icon-css/flags/4x3/si.svg?7f576d8798a8732afa465065bff56a6b";